import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import CrossIcon from '@atlaskit/icon/utility/cross';
import { Box, Flex, Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { useAIContext } from '@atlassian/ai-smart-button-api';

export const i18n = defineMessages({
	closeButtonLabel: {
		id: 'ai-smart-button.reference.close-button-label',
		defaultMessage: 'Close',
		description: 'Label for the close button',
	},
});

const styles = cssMap({
	reference: {
		paddingBlock: token('space.100'),
		paddingInline: token('space.150'),
		backgroundColor: token('elevation.surface'),
		borderStyle: 'solid',
		borderWidth: token('border.width'),
		borderRadius: token('border.radius.100'),
		borderColor: token('color.border'),
	},
	container: {
		paddingTop: token('space.025'),
		paddingBottom: token('space.250'),
		paddingLeft: token('space.300'),
		paddingRight: token('space.300'),
	},
});

export function Reference() {
	const context = useAIContext();
	const intl = useIntl();
	const reference = context?.reference;
	const onRemove = context?.onRemove;

	return (
		<Box xcss={styles.container} backgroundColor="elevation.surface.sunken">
			<Flex xcss={styles.reference} alignItems="center">
				<Inline grow="fill">
					<Text size="medium" weight="semibold" maxLines={1}>
						{reference}
					</Text>
				</Inline>
				<IconButton
					testId="remove-reference-button"
					appearance="subtle"
					icon={CrossIcon}
					label={intl.formatMessage(i18n.closeButtonLabel)}
					spacing="compact"
					onClick={onRemove}
				/>
			</Flex>
		</Box>
	);
}
